/** Merged Korean Near Me copy (flagship wave 1 + wave 2). */
import { NEAR_KO_COPY, type NearKoCopy } from "./ko-copy";
import { NEAR_KO2_COPY } from "./ko-copy-2";
import type { NearKoAnyKey } from "./ko-keys";

export const NEAR_KO_ALL_COPY: Record<NearKoAnyKey, NearKoCopy> = {
  ...NEAR_KO_COPY,
  ...NEAR_KO2_COPY,
};
